import { render } from "./SidebarAndPanesWithRouting.vue?vue&type=template&id=03ba250d&lang=pug"
import script from "./SidebarAndPanesWithRouting.vue?vue&type=script&lang=js"
export * from "./SidebarAndPanesWithRouting.vue?vue&type=script&lang=js"

import "./SidebarAndPanesWithRouting.vue?vue&type=style&index=0&id=03ba250d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__